<template>
  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
    <div class="dropbox">
      <input
        type="file"
        multiple
        :name="uploadFieldName"
        :disabled="isSaving"
        @change="
          filesChange($event.target.name, $event.target.files);
          fileCount = $event.target.files.length;
        "
        accept="image/*"
        class="input-file"
      />
      <p v-if="isInitial">
        Drag your file(s) here to begin<br />
        or click to browse
      </p>
      <p v-if="isSaving">Uploading {{ fileCount }} files...</p>
    </div>
  </form>
</template>

<script>

import AWS from 'aws-sdk'
import { S3Client } from '@/services'

const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3

export default {
  name: 's3-multi-upload-form',
  props: {
    bucket: {
      type: String,
      required: true
    },
    prefix: {
      type: String,
      required: false,
      default: null
    },
    imageResetToken: { // use UUID value when you want to reset
      type: String,
      required: true,
      default: 'initial'
    }
  },
  data () {
    return {
      // uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'campaignImages'
    }
  },
  computed: {
    isInitial () {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  watch: {
    currentStatus: function (newVal, oldVal) {
      switch (newVal) {
        case STATUS_SUCCESS:
          this.$emit('upload-success', true)
          break
        case STATUS_FAILED:
          this.$emit('upload-failure', this.uploadError)
          break
        default:
          break
      }
    },
    imageResetToken: function () {
      this.reset()
    }
  },
  methods: {
    async upload (file) {
      const s3Client = await S3Client.getService()
      const keyName = this.prefix ? `${this.prefix}/${file.name}` : file.name
      return new Promise((resolve, reject) => {
        const mUpload = new AWS.S3.ManagedUpload({
          service: s3Client,
          params: {
            Bucket: this.bucket,
            Key: keyName,
            Body: file
          }
        })
        mUpload.send((err, data) => {
          if (err) {
            reject(err)
          } else {
            resolve(data)
          }
        })
      })
    },
    reset () {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      // this.uploadedFiles = []
      this.uploadError = null
    },
    save (fileList) {
      this.currentStatus = STATUS_SAVING
      const uploadPromises = Array.from(fileList).map(file => this.upload(file))
      Promise.all(uploadPromises)
        .then(uploadResults => {
          this.uploadError = null
          this.currentStatus = STATUS_SUCCESS
        })
        .catch(err => {
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
        })
    },
    filesChange (fieldName, fileList) {
      // handle file changes
      if (!fileList.length) {
        return null
      } else {
        this.reset()
        return this.save(fileList)
      }
    }
  },
  mounted () {
    this.reset()
  }
}
</script>

<style scoped lang="scss">
  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
</style>
